import { UserHeader } from "./user";
import { Type } from "class-transformer";

export interface IDiary
{
    createdDate?: Date,
    createdBy?: UserHeader,
    subject?:string,
    body?: string,
    dueDate? : Date;
    closedDate ? : Date;
    assignedTo?: UserHeader;
    closedBy?:UserHeader;
    encounterId?:number;
}


export class Diary implements IDiary
{
    constructor
    (
        public id: number,
        public createdDate: Date,
        public createdBy: UserHeader,
        public subject:string,
        public body: string
    )
    {
        
    }

    @Type(() => Date)
    dueDate? : Date;

    @Type(() => Date)
    closedDate ? : Date;

    @Type(() => UserHeader)
    assignedTo?: UserHeader;

    @Type(() => Date)
    closedBy?:UserHeader;
    encounterId?:number;
    get closed():boolean
    {
        return this.closedDate != undefined;
    }
    get criticalDate():Date
    {
        if(this.closed && this.closedDate)
        {
            return this.closedDate;
        }
        else if (!this.closed && this.dueDate)
        {
            return this.dueDate;
        }
        else
        {
            return this.createdDate;
        }
    }
}

export class DiaryUpdate
{
    constructor
    (
        public diaryId:number

    )
    {

    }

    dueDate? :Date;
    closedDate? :Date;
    assignedToId?: number;
    closedById?: number;
    subject?: string;
    body? : string;

}


export class DiaryInsert
{
    constructor
    (
        public createdById: number,
        public subject: string,
        public body: string
    )
    {

    }

    public assignedToId? : number;
    public dueDate? : Date;

}